// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"62205db7","466":"62205db7"}[chunkId] + ".chunk.css";
};